import { LoggerService } from '../../common/common.module'

import { TARIFF_SERVICE_NAME, TariffService } from '../../../services/tariff'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../services/user-session'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

import { TariffCreateEditController } from './tariffs-create-edit.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './tariffs-create-edit.tpl.html'

//#endregion


// #region Setup

export class TariffCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', USER_SESSION_SERVICE_NAME, TARIFF_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        userSessionService: UserSessionService,
        tariffService: TariffService
    ) => new TariffCreateEditController(
        $scope,
        $q,
        $timeout,
        logger,
        userSessionService,
        tariffService,
        TariffService.REFERENCE_TYPE,
        TariffService.SIMAX_MODULE_NAME
    )
    ]

    template = TEMPLATE
}

// #endregion
